import { Card, CardContent, Skeleton, Box } from '@mui/material';

// Stat Card Skeleton (for dashboard summary cards)
export const StatCardSkeleton = ({ count = 4 }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: `repeat(${count}, 1fr)` },
        gap: { xs: 1.5, sm: 2 },
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Card
          key={index}
          elevation={0}
          sx={{
            border: '1px solid',
            borderColor: 'grey.200',
            borderRadius: 2,
            height: { xs: 100, sm: 120 },
          }}
        >
          <CardContent
            sx={{
              p: { xs: 1.5, sm: 2.5 },
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: { xs: 1, sm: 2 },
                width: '100%',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={80} height={16} sx={{ mb: 0.5 }} />
                <Skeleton variant="text" width={50} height={36} />
              </Box>
              <Skeleton
                variant="rounded"
                width={48}
                height={48}
                sx={{ borderRadius: 2 }}
              />
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

// Project Card Skeleton
export const ProjectCardSkeleton = () => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'grey.100',
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
          <Skeleton variant="rounded" width={48} height={48} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={18} />
          </Box>
          <Skeleton variant="rounded" width={80} height={24} />
        </Box>
        <Skeleton variant="text" width="100%" height={16} />
        <Skeleton variant="text" width="80%" height={16} />
        <Box sx={{ mt: 2 }}>
          <Skeleton variant="rounded" width="100%" height={8} sx={{ borderRadius: 4 }} />
        </Box>
      </CardContent>
    </Card>
  );
};

// Content Card Skeleton (for general content cards)
export const ContentCardSkeleton = ({ hasHeader = true, lines = 3 }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        backgroundColor: '#fff',
        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
        border: '1px solid',
        borderColor: 'grey.100',
      }}
    >
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        {hasHeader && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
            <Skeleton variant="rounded" width={8} height={24} />
            <Skeleton variant="text" width={150} height={28} />
          </Box>
        )}
        {Array.from({ length: lines }).map((_, index) => (
          <Skeleton
            key={index}
            variant="text"
            width={index === lines - 1 ? '60%' : '100%'}
            height={20}
            sx={{ mb: 1 }}
          />
        ))}
      </CardContent>
    </Card>
  );
};

// Default export for backward compatibility
const CardSkeleton = StatCardSkeleton;
export default CardSkeleton;
